import { create } from "zustand";
/**
 * Показан ли сейчас пейвол на экране. `PaywallPage` выставляет `true` на маунте
 * и `false` на анмаунте. Другие части UI читают флаг, чтобы НЕ отвлекать от
 * пейвола — напр. центр уведомлений (колокольчик) прячется поверх «Спец.
 * предложения» с таймером.
 */
export const usePaywallActive = create((set) => ({
    active: false,
    setActive: (active) => set({ active }),
}));
